import { combineReducers } from 'redux';
import { reducer as subscription } from './subscription';

const rootReducer = combineReducers({
    subscription
});

export default rootReducer;
